import { render, staticRenderFns } from "./index-course.vue?vue&type=template&id=2b7985cc&scoped=true&"
import script from "./index-course.vue?vue&type=script&lang=js&"
export * from "./index-course.vue?vue&type=script&lang=js&"
import style0 from "./index-course.vue?vue&type=style&index=0&id=2b7985cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7985cc",
  null
  
)

export default component.exports